export default "__VITE_ASSET__DChyN$0V__"